const Photo = ({ base64, src, alt, className }) => {
    if (base64) return <img src={`data:image/png;base64,${base64}`} alt={alt} className={className ? className : undefined} />;
    if (src) return <img src={src} alt={alt} className={className ? className : undefined} />;
    return <p>Image was not found</p>;
}

export default Photo;